import { Image } from "antd";
import PropTypes from "prop-types";
import React from "react";
import entete from "../../../../assets/img/entete.jpg";
import { frenchMonth } from "../../../../variables/functions";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import { DocumentFooter } from "../../../../components/docs/DocumentFooter";
import DocumentHeader from "../../../../components/docs/DocumentHeader";

const CompteDeCessionParCategorieParCompagnie = React.forwardRef((props, ref) => {
    const montantSouscriptions = props?.totals ? props?.totals?.totalEmissions : props?.souscriptions ? props?.souscriptions?.reduce((sum, reglement) => reglement.data.montant > 0 ? sum + reglement.data.montant : sum, 0) : 0;
    const montantAnnulations = props?.totals ? props?.totals?.totalAnnulations : props?.souscriptions ? props?.souscriptions?.reduce((sum, reglement) => reglement.data.montant < 0 ? sum + reglement.data.montant : sum, 0) : 0;
    const montantSinistresPayes = props?.totals ? props?.totals?.totalSinistres : props?.sinistres ? props?.sinistres?.reduce((sum, sinistre) => sum + sinistre.montant, 0) : 0;
    const montantRecoursSinistres = props?.totals ? props?.totals?.totalRecours : props?.sinistres ? props?.sinistres?.reduce((sum, sinistre) => sinistre.recours ? sum + sinistre.montant : sum, 0) : 0;
    const indemniteDeGestion = props?.totals ? props?.totals?.indemnitesEmissions : montantSouscriptions * 0.15;
    const indemniteDeGestionAnnulations = props?.totals ? props?.totals?.indemnitesAnnulations : montantAnnulations * 0.15;
    const difference = props?.totals ? props?.totals?.debit - props?.totals?.credit : (montantSouscriptions + Math.abs(montantAnnulations)) - (indemniteDeGestion + Math.abs(indemniteDeGestionAnnulations) + montantSinistresPayes + montantRecoursSinistres);

    return (
        <div className="col-12"
            style={{
                width: "210mm",
                height: "297mm",
                margin: 0,
                padding: 0,
                pageBreakInside: "avoid",
                fontFamily: "'Times New Roman', Times, serif"
            }}
            ref={ref}
        >
            <div className="card" style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "297mm",
                position: "relative"
            }}>
                <DocumentHeader typeOrganisme={"ASSURANCE"} logoPreviewUrl={props?.logoPreviewUrl} />

                <div
                    className=""
                    style={{
                        padding: "5mm",
                        boxSizing: "border-box",
                        flex: "1"
                    }}
                >
                    <div className="">
                        <div className="row">
                            <div className="col-12">
                                <table
                                    className="table table-bordered"
                                    style={{ width: "40%" }}
                                >
                                    <tbody>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <strong>COMPTE DE CESSION</strong>
                                            </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <strong>Catégorie: {props?.categorie?.codeCategorie === "M" ? "MOTO" : "TPV"}</strong>
                                            </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <em><strong>Période: {frenchMonth(props?.periode?.split("-")?.[1])} {props?.periode?.split("-")?.[0]}</strong></em>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div style={{ marginLeft: "360px" }}>
                            <p style={{ fontWeight: "bold" }}><strong>{props?.compagnie?.raisonSociale}</strong></p>
                            <p style={{ fontWeight: "bold" }}><strong>{props?.compagnie?.siegeSocial}</strong></p>
                            <p style={{ fontWeight: "bold" }}><strong>Tel: {props?.compagnie?.telephone1 ? props?.compagnie?.telephone1 : ""} {props?.compagnie?.telephone2 ? ` / ${props?.compagnie?.telephone2}` : ""}</strong></p>
                            <p style={{ fontWeight: "bold" }}><strong>LOME</strong></p>
                        </div>

                        <br />

                        <div className="row">
                            <div className="col-12">
                                <table
                                    className="table table-bordered"
                                    style={{ width: "100%" }}
                                >
                                    <thead>
                                        <tr style={{ lineHeight: "1" }}>
                                            <th>Postes</th>
                                            <th className="text-center">Débit</th>
                                            <th className="text-center">Crédit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                MONTANT TOTAL DES SOUSCRIPTIONS
                                            </td>
                                            <td className="text-end"></td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.totalEmissions)}
                                            </td>
                                        </tr>
                                        {props?.totals?.totalAnnulations > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                ANNULATIONS ET RISTOURNES
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(Math.abs(props?.totals?.totalAnnulations))}
                                            </td>
                                            <td className="text-end">
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                INDEMNITE DE GESTION (15%)
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.indemnitesEmissions)}
                                            </td>
                                            <td className="text-end">
                                            </td>
                                        </tr>
                                        {props?.totals?.indemnitesAnnulations > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                INDEMNITE DE GESTION SUR ANNULATION (15%)
                                            </td>
                                            <td className="text-end">
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(Math.abs(props?.totals?.indemnitesAnnulations))}
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                SINISTRES PAYES
                                            </td>
                                            <td className="text-end">{displayNumbers(props?.totals?.totalSinistres)}</td>
                                            <td className="text-end"></td>
                                        </tr>
                                        {props?.totals?.totalRecours > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                RECOURS ENCAISSES
                                            </td>
                                            <td className="text-end">
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.totalRecours)}
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                <strong>SOLDE EN FAVEUR {props?.totals.soldeEnFaveurDe}</strong>
                                            </td>
                                            <td className="text-end">{props?.totals?.solde < 0 ? displayNumbers(props?.totals?.soldeMontant) : ""}</td>
                                            <td className="text-end">{props?.totals?.solde > 0 ? displayNumbers(props?.totals?.soldeMontant) : ""}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ lineHeight: "1" }}>
                                            <th>BALANCE</th>
                                            <th className="text-end">{displayNumbers(difference >= 0 ? props?.totals?.debit : props?.totals?.credit)}</th>
                                            <th className="text-end">{displayNumbers(difference >= 0 ? props?.totals?.debit : props?.totals?.credit)}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                <br />
                                <div style={{ marginLeft: "500px" }}>
                                    <div className="row">
                                        <div className="col-12">
                                            <u><strong>Directeur du Pool</strong></u>
                                        </div>

                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <div className="col-12">
                                            <strong>Koffi G. WARBUTIN</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DocumentFooter
                    style={{
                        width: "100%",
                        marginTop: "auto"
                    }}
                />
            </div>
        </div>
    );
});

CompteDeCessionParCategorieParCompagnie.propTypes = {
    souscriptions: PropTypes.array,
    sinistres: PropTypes.array,
    categorie: PropTypes.object,
    compagnie: PropTypes.object,
    periode: PropTypes.string,
    totals: PropTypes.object
};
export default CompteDeCessionParCategorieParCompagnie;
